import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore } from 'redux';

import './index.css';
import reducer from './reducer';
import Routes from './routes';
import registerServiceWorker from './registerServiceWorker';

//Setup app language
const lang = window.navigator.language.indexOf('ru') !== -1? 'ru' : 'en';
localStorage.setItem('lang', lang);

const store = createStore(
  reducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()
);

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <Routes />
    </BrowserRouter>
  </Provider>, document.getElementById('root'));
registerServiceWorker();


// WEBPACK FOOTER //
// ./src/index.js